import React from "react";
import { IconProps } from "./types";

function IconReports(props: IconProps) {
  return (
    <svg
      id="insights-reports"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <rect
        id="Rectangle_427"
        data-name="Rectangle 427"
        width="24"
        height="24"
        fill="none"
      />
      <g
        id="Group_99"
        data-name="Group 99"
        transform="translate(2.833 2.833)"
        fill="currentColor"
      >
        <path
          id="Path_248"
          data-name="Path 248"
          d="M12.375,4.5h3.333v8.448H12.375Z"
          transform="translate(-7.375 5.386)"
        />
        <path
          id="Path_249"
          data-name="Path 249"
          d="M5.625,23.625H8.958v5.5H5.625Z"
          transform="translate(-5.625 -10.792)"
        />
        <path
          id="Path_250"
          data-name="Path 250"
          d="M19.125,19.125h3.333V26.2H19.125Z"
          transform="translate(-9.125 -7.863)"
        />
        <path
          id="Path_251"
          data-name="Path 251"
          d="M25.875,12.375h3.333V25.734H25.875Z"
          transform="translate(-10.874 -7.4)"
        />
        <path
          id="Path_276"
          data-name="Path 276"
          d="M16.952,6.775a.6.6,0,0,0,0-.163.5.5,0,0,0-.039-.132.852.852,0,0,0-.07-.109.581.581,0,0,0-.109-.132l-.093-.054a.535.535,0,0,0-.147-.078H16.34A.543.543,0,0,0,16.177,6H12.3a.775.775,0,1,0,0,1.55h2.194l-3.1,3.651L8.046,9.209a.775.775,0,0,0-.992.171L3.178,14.03a.776.776,0,0,0,1.194.992l3.449-4.139,3.31,1.984a.775.775,0,0,0,.984-.163L15.4,8.868v1.783a.775.775,0,1,0,1.55,0Z"
          transform="translate(-2.998 -6)"
        />
      </g>
    </svg>
  );
}

export default IconReports;
